module.exports = __webpack_public_path__ + "static/media/cards.308f1bec.png";